export default "__VITE_ASSET__DMD7tKol__"